import Button from '@hotmart/space-lib/dist/components/button'

import ModalFooter from 'src/components/Modal/footer'
import i18n from 'src/i18n'

import { SchedulePostModalFooterProps } from './types'

const SchedulePostModalFooter = ({
  isDisabledClearForm,
  handleClear,
  handleGoBack,
  handleSubmit,
  formId,
  formIsInvalid,
  children,
  shouldShowSubmitBtn = true
}: SchedulePostModalFooterProps) => (
  <ModalFooter className="_d-flex _justify-content-end _bg-gray-100">
    {!isDisabledClearForm ? (
      <Button
        disabled={isDisabledClearForm}
        variation="default"
        className="_border-0 _mr-4 _text-gray-900"
        onClick={handleClear}
      >
        {i18n.t('modals.schedule_posts.buttons.remove_schedule')}
      </Button>
    ) : null}

    <Button variation="default" onClick={handleGoBack}>
      {i18n.t('modals.schedule_posts.buttons.back')}
    </Button>

    {shouldShowSubmitBtn ? (
      <Button disabled={formIsInvalid} form={formId} className="_ml-4" onClick={handleSubmit}>
        {i18n.t('modals.schedule_posts.buttons.save')}
      </Button>
    ) : null}

    {children}
  </ModalFooter>
)

export default SchedulePostModalFooter
